export default {
  UPGRADE_SUBSCRIPTION_BANNER: '@MYYOLA/UPSELL_BANNER_TYPES/UPGRADE_SUBSCRIPTION_BANNER',
  SWITCH_TO_ANNUAL_BANNER: '@MYYOLA/UPSELL_BANNER_TYPES/SWITCH_TO_ANNUAL_BANNER',
  ONLINE_STORE_BANNER: '@MYYOLA/UPSELL_BANNER_TYPES/ONLINE_STORE_BANNER',
  CUSTOM_DOMAIN_BANNER: '@MYYOLA/UPSELL_BANNER_TYPES/CUSTOM_DOMAIN_BANNER',
};
